import type { RouteRecordRaw } from 'vue-router'

// Lazy loading para otimização
const Architecture = () => import('@/views/architecture/Architecture.vue')
const ArchitectureDiagrams = () => import('@/views/architecture/ArchitectureDiagrams.vue')
const BusinessArchitecture = () => import('@/views/architecture/business/BusinessArchitecture.vue')
const BusinessArchitectureOld = () => import('@/views/architecture/business/BusinessArchitectureOld.vue')
const BusinessArchitectureDetails = () => import('@/views/architecture/business/BusinessArchitectureDetails.vue')
const BusinessArchitectureCapabilityCommom = () => import('@/views/architecture/business/BusinessArchitectureCapabilityCommom.vue')
const BusinessArchitectureCapabilityInvoice = () => import('@/views/architecture/business/BusinessArchitectureCapabilityInvoice.vue')
const BusinessArchitectureCapabilityOrder = () => import('@/views/architecture/business/BusinessArchitectureCapabilityOrder.vue')
const BusinessArchitectureCapabilityCustomer = () => import('@/views/architecture/business/BusinessArchitectureCapabilityCustomer.vue')
const ApplicationArchitecture = () => import('@/views/architecture/application/ApplicationArchitecture.vue')
const ApplicationArchitectureOld = () => import('@/views/architecture/application/ApplicationArchitectureOld.vue')
const ApplicationArchitectureDetails = () => import('@/views/architecture/application/ApplicationArchitectureDetails.vue')
const ApplicationArchitectureDetailsCollectionReceivement = () => import('@/views/architecture/application/ApplicationArchitectureDetailsCollectionReceivement.vue')
const ApplicationArchitectureDetailsCommon = () => import('@/views/architecture/application/ApplicationArchitectureDetailsCommon.vue')
const TechnologyArchitecture = () => import('@/views/architecture/technology/TechnologyArchitecture.vue')
const ProductsArchitecture = () => import('@/views/architecture/products/ProductsArchitecture.vue')
// Produtos - camadas específicas
const ProductBusinessArchitectureDetails = () => import('@/views/architecture/products/business/BusinessArchitectureDetails.vue')
const ProductApplicationArchitecture = () => import('@/views/architecture/products/application/ApplicationArchitecture.vue')
const ProductApplicationArchitectureDetails = () => import('@/views/architecture/products/application/ApplicationArchitectureDetails.vue')
const ProductTechnologyArchitectureDetails = () => import('@/views/architecture/products/technology/TechnologyArchitectureDetails.vue')
const ProductDataArchitecture = () => import('@/views/architecture/products/data/DataArchitecture.vue')
const ProductDataArchitectureDetails = () => import('@/views/architecture/products/data/DataArchitectureDetails.vue')

const architectureRoutes: RouteRecordRaw[] = [
  {
    path: '/architecture',
    name: 'Architecture',
    component: Architecture,
    meta: { 
      requiresAuth: true, 
      requiredItem: 'architecture',
      title: 'Arquitetura',
      breadcrumbTitle: 'Arquitetura'
    }
  },
  {
    path: '/architecture/diagrams',
    name: 'ArchitectureDiagrams',
    component: ArchitectureDiagrams,
    meta: { 
      requiresAuth: true, 
      requiredItem: 'architecture.diagrams',
      title: 'Diagramas de Arquitetura',
      breadcrumbTitle: 'Diagramas'
    }
  },
  {
    path: '/architecture/business-old',
    name: 'BusinessArchitectureOld',
    component: BusinessArchitectureOld,
    meta: { 
      requiresAuth: true, 
      requiredItem: 'architecture.business',
      title: 'Arquitetura de Negócio - Antigo',
      breadcrumbTitle: 'Negócio - Antigo'
    }
  },
  {
    path: '/architecture/business',
    name: 'BusinessArchitecture',
    component: BusinessArchitecture,
    meta: { 
      requiresAuth: true, 
      requiredItem: 'architecture.business', 
      title: 'Arquitetura de Negócio', 
      breadcrumbTitle: 'Arquitetura de Negócio' 
    },
    children: [
      {
        path: 'details/:id',
        name: 'BusinessArchitectureDetails',
        component: BusinessArchitectureDetails,
        meta: { 
          requiresAuth: true, 
          requiredItem: 'architecture.business',
          title: 'Detalhes do Produto',
          breadcrumbTitle: 'Detalhes do Produto'
        },
        children: [
            {
                path: 'customer',
                name: 'Customers',
                component: BusinessArchitectureCapabilityCustomer,
                meta: { 
                    requiresAuth: true, 
                    requiredItem: 'architecture.business',
                    title: 'Gestão de Clientes',
                    breadcrumbTitle: 'Gestão de Clientes'
                }
            },                
            {
                path: 'order',
                name: 'Orders',
                component: BusinessArchitectureCapabilityOrder,
                meta: { 
                    requiresAuth: true, 
                    requiredItem: 'architecture.business',
                    title: 'Gestão de Pedidos',
                    breadcrumbTitle: 'Gestão de Pedidos'
                }
            },
            {
                path: 'catalog',
                name: 'Catalog',
                component: BusinessArchitectureCapabilityCommom,
                meta: { 
                    requiresAuth: true, 
                    requiredItem: 'architecture.business',
                    title: 'Catálogo de Produtos',
                    breadcrumbTitle: 'Catálogo de Produtos'
                }
            },     
            {
                path: 'pricing',
                name: 'Pricing',
                component: BusinessArchitectureCapabilityCommom,
                meta: { 
                    requiresAuth: true, 
                    requiredItem: 'architecture.business',
                    title: 'Tarifação',
                    breadcrumbTitle: 'Tarifação'
                }
            },
            {
                path: 'billing',
                name: 'Billing',
                component: BusinessArchitectureCapabilityCommom,
                meta: { 
                    requiresAuth: true, 
                    requiredItem: 'architecture.business',
                    title: 'Faturamento',
                    breadcrumbTitle: 'Faturamento'
                }
            },                                                     
            {
                path: 'invoice',
                name: 'Invoices',
                component: BusinessArchitectureCapabilityInvoice,
                meta: { 
                    requiresAuth: true, 
                    requiredItem: 'architecture.business',
                    title: 'Gestão de Cobrança',
                    breadcrumbTitle: 'Gestão de Cobrança'
                }
            },
            {
                path: 'provisioning',
                name: 'Provisioning',
                component: BusinessArchitectureCapabilityCommom,
                meta: { 
                    requiresAuth: true, 
                    requiredItem: 'architecture.business',
                    title: 'Provisionamento',
                    breadcrumbTitle: 'Provisionamento'
                }
            }, 
            {
                path: 'usage',
                name: 'Usage',
                component: BusinessArchitectureCapabilityCommom,
                meta: { 
                    requiresAuth: true, 
                    requiredItem: 'architecture.business',
                    title: 'Uso',
                    breadcrumbTitle: 'Uso'
                }
            },
            {
                path: 'communication',
                name: 'Communication',
                component: BusinessArchitectureCapabilityCommom,
                meta: { 
                    requiresAuth: true, 
                    requiredItem: 'architecture.business',
                    title: 'Comunicação',
                    breadcrumbTitle: 'Comunicação'
                }
            },                                     
            {
                path: 'accounting',
                name: 'Accounting',
                component: BusinessArchitectureCapabilityCommom,
                meta: { 
                    requiresAuth: true, 
                    requiredItem: 'architecture.business',
                    title: 'Contabilidade',
                    breadcrumbTitle: 'Contabilidade'
                }
            },
            {
                path: 'fiscal',
                name: 'Fiscal',
                component: BusinessArchitectureCapabilityCommom,
                meta: { 
                    requiresAuth: true, 
                    requiredItem: 'architecture.business',
                    title: 'Fiscal',
                    breadcrumbTitle: 'Fiscal'
                }
            }
        ]
      }
    ]
  },
  {
    path: '/architecture/application-old',
    name: 'ApplicationArchitectureOld',
    component: ApplicationArchitectureOld,
    meta: { 
      requiresAuth: true, 
      requiredItem: 'architecture.application',
      title: 'Arquitetura de Aplicação - Antigo',
      breadcrumbTitle: 'Aplicação - Antigo'      
    }
  },
  {
    path: '/architecture/application',
    name: 'ApplicationArchitecture',
    component: ApplicationArchitecture,
    meta: { 
      requiresAuth: true, 
      requiredItem: 'architecture.application',
      title: 'Arquitetura de Aplicação',
      breadcrumbTitle: 'Aplicação'
    },
    children: [
      {
        path: 'details/:id',
        name: 'ApplicationArchitectureDetails',
        component: ApplicationArchitectureDetails,
        meta: { 
          requiresAuth: true, 
          requiredItem: 'architecture.application',
          title: 'Detalhes do Produto',
          breadcrumbTitle: 'Detalhes do Produto'
        }, 
        children: [
          {
              path: 'omnichannel',
              name: 'Omnichannel',
              component: ApplicationArchitectureDetailsCommon,
              meta: { 
                  requiresAuth: true, 
                  requiredItem: 'architecture.application',
                  title: 'Omnichannel',
                  breadcrumbTitle: 'Omnichannel'
              }
          },              
          {
            path: 'collection-receivement',
            name: 'CollectionReceivement',
            component: ApplicationArchitectureDetailsCollectionReceivement,
            meta: { 
              requiresAuth: true, 
              requiredItem: 'architecture.application',
              title: 'Collection Receivement',
              breadcrumbTitle: 'Collection Receivement'
            }
          },
            {
              path: 'provisioning-connector',
              name: 'ProvisioningConnector',
              component: ApplicationArchitectureDetailsCommon,
              meta: { 
                requiresAuth: true, 
                requiredItem: 'architecture.application',
                title: 'Provisioning Connector',
                breadcrumbTitle: 'Provisioning Connector'
              }
            },
            {
              path: 'usage-connector',
              name: 'UsageConnector',
              component: ApplicationArchitectureDetailsCommon,
              meta: { 
                requiresAuth: true, 
                requiredItem: 'architecture.application',
                title: 'Usage Connector',
                breadcrumbTitle: 'Usage Connector'
              }
            },
            {
              path: 'subscription-connector',
              name: 'SubscriptionConnector',
              component: ApplicationArchitectureDetailsCommon,
              meta: { 
                requiresAuth: true, 
                requiredItem: 'architecture.application',
                title: 'Subscription Connector',
                breadcrumbTitle: 'Subscription Connector'
              }
            },
            {
              path: 'notification-service',
              name: 'NotificationService',
              component: ApplicationArchitectureDetailsCommon,
              meta: { 
                requiresAuth: true, 
                requiredItem: 'architecture.application',
                title: 'Notification Service',
                breadcrumbTitle: 'Notification Service'
              }
            },
            {
              path: 'sydleone',
              name: 'SydleOne',
              component: ApplicationArchitectureDetailsCommon,
              meta: { 
                requiresAuth: true, 
                requiredItem: 'architecture.application',
                title: 'SydleOne',
                breadcrumbTitle: 'SydleOne'
              }
            },
            {
              path: 'roterizador-nucleo',
              name: 'RoteirizadorNucleo',
              component: ApplicationArchitectureDetailsCommon,
              meta: { 
                requiresAuth: true, 
                requiredItem: 'architecture.application',
                title: 'Roteirizador Nucleo',
                breadcrumbTitle: 'Roteirizador Nucleo'
              }
            }
        ]
      }
    ]
  },
  {
    path: '/architecture/technology',
    name: 'TechnologyArchitecture',
    component: TechnologyArchitecture,
    meta: { 
      requiresAuth: true, 
      requiredItem: 'architecture.technology',
      title: 'Arquitetura Tecnológica',
      breadcrumbTitle: 'Tecnologia'
    }
  },
  {
    path: '/architecture/enterprise-architecture',
    name: 'EnterpriseArchitecture',
    component: ProductsArchitecture,
    meta: { 
      requiresAuth: true, 
      requiredItem: 'architecture.products',
      title: 'Arquitetura Corporativa',
      breadcrumbTitle: 'Arquitetura Corporativa'
    },
    children: [
      // Rotas das camadas de arquitetura no contexto do produto
      {
        path: 'business',
        name: 'ProductBusinessArchitectureDetails',
        component: ProductBusinessArchitectureDetails,
        meta: {
          requiresAuth: true,
          requiredItem: 'architecture.products',
          title: 'Arquitetura de Negócio',
          breadcrumbTitle: 'Negócio'
        }
      },
      {
        path: 'application',
        name: 'ProductApplicationArchitecture',
        component: ProductApplicationArchitecture,
        meta: {
          requiresAuth: true,
          requiredItem: 'architecture.products',
          title: 'Arquitetura de Aplicação',
          breadcrumbTitle: 'Aplicação'
        },
        children: [
          {
            path: 'details',
            name: 'ProductApplicationArchitectureDetails',
            component: ProductApplicationArchitectureDetails,
            meta: {
              requiresAuth: true,
              requiredItem: 'architecture.products',
              title: 'Detalhes da Aplicação',
              breadcrumbTitle: 'Detalhes'
            }
          }
        ]
      },
      {
        path: 'technology',
        name: 'ProductTechnologyArchitectureDetails',
        component: ProductTechnologyArchitectureDetails,
        meta: {
          requiresAuth: true,
          requiredItem: 'architecture.products',
          title: 'Arquitetura de Tecnologia',
          breadcrumbTitle: 'Tecnologia'
        }
      },
      {
        path: 'data',
        name: 'ProductDataArchitecture',
        component: ProductDataArchitecture,
        meta: {
          requiresAuth: true,
          requiredItem: 'architecture.products',
          title: 'Arquitetura de Dados',
          breadcrumbTitle: 'Dados'
        },
        children: [
          {
            path: 'details',
            name: 'ProductDataArchitectureDetails',
            component: ProductDataArchitectureDetails,
            meta: {
              requiresAuth: true,
              requiredItem: 'architecture.products',
              title: 'Detalhes da Aplicação',
              breadcrumbTitle: 'Detalhes'
            }
          }
        ]
      }
    ]
  }
]

export default architectureRoutes